import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class GamePaused extends BaseScene {

    constructor() {
        super({key: 'GamePaused'});
    }

    public init() {
        super.init();
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_main_medium_01');

        const title = this.add.text(0, -165, translate.key('game_paused_title'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 50,
                color: '#fff'
            })
            .setStroke('#212121', 6);

        const description = this.add.text(0, -10, this.getRandomMessage())
            .setOrigin(0.5)
            .setWordWrapWidth(254)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 24,
                color: '#3d3d3d',
                align: 'center'
            });

        const replayButton = new ButtonSprite(this, -105, 145, 'button_replay', 2, () => this.replayGame());

        const nextButton = new ButtonSprite(this, 105, 145, 'button_next', 2,() => this.continueGame());

        const menuButton = new ButtonSprite(this, 0, 145, 'button_menu', 2, () => this.extiToMenu());

        const container = this.add.container(this.width / 2, -300).add([panel, title, description, replayButton, nextButton, menuButton]);

        // Tween
        this.tweens.add({
            y: 460,
            targets: container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

    }

    private getRandomMessage(): string {
        const messages = [
            translate.key('game_paused_text_1'),
            translate.key('game_paused_text_2'),
            translate.key('game_paused_text_3'),
            translate.key('game_paused_text_4'),
            translate.key('game_paused_text_5'),
            translate.key('game_paused_text_6'),
            translate.key('game_paused_text_7'),
            translate.key('game_paused_text_8'),
            translate.key('game_paused_text_9'),
            translate.key('game_paused_text_10'),
            translate.key('game_paused_text_11'),
            translate.key('game_paused_text_12'),
        ];
        const randomIndex = Math.floor(Math.random() * messages.length);
        return messages[randomIndex];
    }

    private replayGame() {
        this.getBootloaderScene().launchScene('GameLevel');
    }

    private continueGame() {
        this.scene.sendToBack('GamePaused');
        this.scene.stop('GamePaused');
        this.scene.resume('GameUI');
        this.scene.resume('GameLevel');
    }

    private extiToMenu() {
        this.getBootloaderScene().launchScene('MainMenu');
    }
}